export var issueInMonographs = function (issue) {
    var _a = issue, agenda = _a.agenda, linkedMonographTitleId = _a.linkedMonographTitleId;
    if (agenda !== "MONOGRAPHS" || issue.continuedFromPreviousVolume) {
        return null;
    }
    return linkedMonographTitleId ? "linked" : "own";
};
